import { AuditEntity } from "@app/common";
import { Cost } from "@app/core";
import { Client, Customer } from "@app/customers-base";
import { Order } from "@app/orders-base";
import { TariffChange } from "@app/products-base";
import { CustomerTariffChangeBundle } from "./customer-tariff-change-bundle";

export class CustomerTariffChange extends AuditEntity {
    clientId: number | null;
    client: Client;
    customerId: number | null;
    customer: Customer;
    orderId: number;
    order: Order;
    tariffChangeId: number | null;
    tariffChange: TariffChange;
    fromTariffId: number | null;
    fromTariffName: string;
    toTariffId: number | null;
    toTariffName: string;
    bundles: CustomerTariffChangeBundle[];
    optionalBundles: CustomerTariffChangeBundle[];
    costs: Cost[] = [];

    /**
     * constructor
     * @param init 
     */
    public constructor(init?: Partial<CustomerTariffChange>) {
        super(init);
        Object.assign(this, init);
    }
}